import { saveAs } from "file-saver";
import { EmployeeRow, QuarterMarginRow, quarterNames, reasonLabels, roleLabels } from "./calc";

// Excel в русской локали ждёт «;» между колонками и запятую в дробях; BOM — чтобы кириллица не поехала
const SEPARATOR = ";";

const cell = (value: string | number | null | undefined) => {
    if (value === null || value === undefined) {
        return "";
    }

    if (typeof value === "number") {
        return (Math.round(value * 100) / 100).toString().replace(".", ",");
    }

    return /[";\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
};

const download = (lines: (string | number | null | undefined)[][], fileName: string) => {
    const text = lines.map((line) => line.map(cell).join(SEPARATOR)).join("\r\n");
    saveAs(new Blob(["﻿" + text], { type: "text/csv;charset=utf-8" }), fileName);
};

/** Таблица юнит-экономики за период — в том виде, в каком она отфильтрована на экране */
export function exportEconomics(rows: EmployeeRow[], title: string) {
    const header = [
        "Сотрудник",
        "Отдел",
        "Должность",
        "Роль",
        "Производственный",
        "Норма, ч",
        "Отработано, ч",
        "На проектах, ч",
        "Доступно, ч",
        "Загрузка, %",
        "Цель загрузки, %",
        "Стоимость часа план, ₽",
        "Стоимость часа факт, ₽",
        "Отклонение, %",
        "Себестоимость труда, ₽",
        "Выработка, ₽",
        "Накладные, ₽",
        "Маржа, ₽",
        "Причина отклонения",
        "Пояснение",
    ];

    const lines = rows.map((r) => [
        r.name,
        r.department,
        r.position,
        roleLabels[r.role],
        r.production ? "да" : "нет",
        r.normHours,
        r.workedHours,
        r.projectHours,
        r.availableHours,
        r.utilization,
        r.benchmark,
        r.planHour,
        r.factHour,
        r.deviation,
        r.factCost,
        r.production ? r.output : null,
        r.production ? r.overhead : null,
        r.production ? r.margin : null,
        r.reason ? r.reason.reasons.map((x) => reasonLabels[x]).join(", ") : "",
        r.reason?.comment ?? "",
    ]);

    download([[title], header, ...lines], `${title}.csv`);
}

/** Маржа производственных сотрудников по кварталам года */
export function exportQuarters(rows: QuarterMarginRow[], year: number) {
    const title = `Маржа по кварталам ${year}`;
    const header = ["Сотрудник", "Отдел", ...quarterNames.map((q) => `${q} квартал, ₽`), `Итого за ${year}, ₽`];
    const lines = rows.map((r) => [r.name, r.department, ...r.quarters, r.total]);

    download([[title], header, ...lines], `${title}.csv`);
}
